<template>
  <div class="queue-board-container">
    <!-- 左侧遮罩层，遮挡外部系统的侧边栏 -->
    <div class="left-mask"></div>
    
    <!-- iframe 容器 -->
    <div class="iframe-wrapper">
      <iframe 
        :src="queueBoardUrl" 
        frameborder="0"
        class="queue-board-iframe"
        @load="onIframeLoad"
      ></iframe>
      
      <!-- 加载中提示 -->
      <div v-if="loading" class="loading-overlay">
        <a-spin size="large" tip="加载队列管理界面中..." />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { getBackendBaseUrl, BACKEND_CONFIG } from '../config/backendUrl';

const loading = ref(true);

// 输出配置信息，方便调试
console.log('[QueueBoard] 后端配置:', BACKEND_CONFIG);

// 队列管理界面URL（直接指向后端API，避免前端路由冲突）
// 注意：iframe 中的请求无法自动携带认证 token，需要在 URL 中添加 token
const queueBoardUrl = computed(() => {
  const baseUrl = getBackendBaseUrl();
  const token = localStorage.getItem('auth_token');
  // 将 token 作为查询参数传递（虽然不太安全，但对于内部管理界面可以接受）
  // 或者后端可以配置允许 iframe 请求携带 cookie
  const url = `${baseUrl}/admin/queues`;
  return token ? `${url}?token=${encodeURIComponent(token)}` : url;
});

const onIframeLoad = () => {
  loading.value = false;
};

onMounted(() => {
  // iframe 加载完成后隐藏加载提示
  setTimeout(() => {
    loading.value = false;
  }, 3000); // 3秒后强制隐藏，防止加载失败时一直显示
});
</script>

<style scoped>
.queue-board-container {
  position: relative;
  width: 100%;
  height: calc(100vh - 0px);
  overflow: hidden;
}

.left-mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 100%;
  background: #001529; /* 与侧边栏背景色一致 */
  z-index: 1;
  pointer-events: none; /* 不阻止鼠标事件 */
}

.iframe-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  margin-left: 0;
}

.queue-board-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 10;
}
</style>
